/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["fr"] = {
    wikiLinkLabel:  "Discute"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/fr/timeline.js
// module id = 585
// module chunks = 3